import AppService, { LocalStorageService, Utilities, AlertService, crypto, track } from 's2s-app-service';
import { doGetConversationList, doDismissPersistent, doAppStatus, doGetUserContacts, doMedia } from './index';
import LoggingService from 's2s-logging-service';

// Since need to authenticate to identity service for contacts, need to always use
// the clear pwd to 'connect' with AppService.
const _useHashPwd = false;

const doShowLogin = (history) => {
  LoggingService.getInstance().info('AC ---- doShowLogin');

  return (dispatch, getState) => {
    try {
      const store = getState(); // jes need to send to connect ... settings
      const creds = LocalStorageService.getData('credentials');
      const isRestarting = LocalStorageService.getData('restarting');

      dispatch ({
        "type": "SHOW_LOGIN",
        "payload": Array.isArray(creds.data) ? {}: creds.data
      });
      history.push('/appmain/login');
      // ok check for creds and do auto login if everything is there
      //console.log('CREDS!!!!', creds);
      // Since we now authenticate to the identity service, can't use the has of the password anymore...user password
      // if (creds && creds.data && creds.data.email && creds.data.hash && (creds.data.remember === true || isRestarting &&
      if (creds && creds.data) {
        // we have credentials from localStorage.  Now determine what password to use (hash or clear)
        let userPassword;
        if (_useHashPwd === true) {
          userPassword = creds.data.hash;
        } else {
          userPassword = creds.data.pwd;
        }

        if (creds.data.email && userPassword && (creds.data.remember === true || isRestarting && isRestarting.data === true) ){
          LoggingService.getInstance().debug('auto log in ', creds);
          dispatch(doingLogin({email: creds.data.email, pwd: creds.data.pwd, remember: creds.data.remember}));
          // jes this is important because settings is not there yet so push to the end of the call stack
          setTimeout(()=>{
            LoggingService.getInstance().debug('auto login CONNECTING ---------------------' );
            // Since we now authenticate to the identity service, can't use the has of the password anymore...use password
            AppService.getInstance().connect(creds.data.email, userPassword, _useHashPwd, true, getState().settings);

          }, 500);

          // remove restarting from local storage since we don't need it anymore
          LocalStorageService.deleteData('restarting');
        }
      }
    } catch(e){
      LoggingService.getInstance().debug('eeee', e);
      //console.log('ERRORORORORORORO', e);
    }
    // dispatch(doingSpeedTest());
    // VertoService.speedTest((data)=>{
    // console.log('doing speed test : ', data);
    //   dispatch(doSpeedTestResults(data))
    // });
  };
};


const doExpiredPassword = (payload, history) => {
  LoggingService.getInstance().info('AC ---- doExpiredPassword');
  return (dispatch) =>{
    history.push('/appmain/resetPassword');
    dispatch ({
      "type": "EXPIRED_PASSWORD",
      "payload": payload,
      "meta": {
        "analytics":{
          'category':'login',
          'action': 'expiredPassword'
        }
      }
    });
  };
};

const doResetPassword = (credentials, pwd1, pwd2) => {
  LoggingService.getInstance().info('AC ---- doResetPassword', credentials, pwd1, pwd2);
  return (dispatch, getState) =>{
    track('login', 'resetPassword', 'email', email);

    const email = credentials.email;
    // TODO remove this line if reset password works...
    //let userpassword = credentials.pwd ? crypto.createHash('sha1').update(credentials.pwd).digest('hex') : credentials.hash;
    let userpassword;
    if (_useHashPwd === true) {
      userpassword = credentials.hash;
    } else {
      userpassword = credentials.pwd;
    }

    const additionalParameters = {
      'change_password': 'true',
      'new_password': pwd1,
      'notnow': 'false'
    };
    // Need to use password instead of hash to connect since also authenticating to the identity service

    //AppService.getInstance().connect(email, userpassword , true, credentials.autologin, getState().settings, additionalParameters);
    AppService.getInstance().connect(email, userpassword , _useHashPwd, credentials.autologin, getState().settings, additionalParameters);

  };
};

const doNotNow = (credentials) => {
  return (dispatch, getState) =>{
    track('login', 'notNow', 'email', email);

    //LoggingService.getInstance().debug('>>>>> doNotNow AC', credentials);
    const email = credentials.email;
    // TODO remove this line if reset password works...
    //let userpassword = credentials.pwd ? crypto.createHash('sha1').update(credentials.pwd).digest('hex') : credentials.hash;
    let userpassword;
    if (_useHashPwd === true) {
      userpassword = credentials.hash;
    } else {
      userpassword = credentials.pwd;
    }
    const additionalParameters = {
      'change_password': 'false',
      'notnow': 'true'
    };
    AppService.getInstance().connect(email, userpassword , _useHashPwd, credentials.autologin, getState().settings, additionalParameters);
  };
};

const doReceiveAuthData = (payload, history) => {
  LoggingService.getInstance().info('AC ---- doReceiveAuthData', payload, history);

  //console.log("HISTORYYYYYYYYYYYYYYYYYYYYYYYYYYYYYY", history)
  return dispatch => {

    const softPhoneExts = payload.extensions.filter((e)=>{
      return e.phone === 129;
    }).sort((a,b)=>{
      return a.extension < b.extension;
    });

    if (softPhoneExts.length === 0){
      AlertService.getInstance().createErrorAlert({
        alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_SOFTPHONE_EXTENSION', 'No softphone extension'),
        alertBodyText: Utilities.getInstance().getIntlMessage('ALERT_MORE_INFORMATION', 'For more information visit:'),
        alertLink: 'http://star2star.com',
        isPersistent: true
      });
      dispatch(doSubmitLogOut(history));
    } else {
      LoggingService.getInstance().debug('----', softPhoneExts[0]);

      if (typeof(BugSnag) !== "undefined"){
        Bugsnag.user = {
            id: softPhoneExts[0].id,
            name: softPhoneExts[0].firstname + softPhoneExts[0].lastname,
            email: softPhoneExts[0].email
        };
      }

      dispatch({
        "type": "AUTH_DATA",
        "payload": payload
      });

      // Get the contacts from the api and put into store!
      dispatch(doGetUserContacts());

    }
  };
};

const doReconnect = () =>{
  LoggingService.getInstance().info('AC ---- doReconnect');
  return (dispatch, getState) =>{
    const store = getState(); // jes need to send to connect ... settings

    // AppService.getInstance().reconnect(store.settings);
    // // giving time for reconnect to finish before setting app status
    // setTimeout(()=>{
    //   dispatch(doAppStatus(AppService.getInstance().getStatus()));
    // }, 1000);
    // setTimeout(()=>{
    //   const socketStatus = AppService.getInstance().getCallService().isSocketReady();
    //   if (!socketStatus){
    //     AppService.getInstance().updateSettings(store.settings);
    //     setTimeout(()=>{
    //       dispatch(doAppStatus(AppService.getInstance().getStatus()));
    //     }, 3000);
    //   }
    // }, 10000);
    //setTimeout(()=>{
      dispatch(doDismissPersistent());
      LoggingService.getInstance().debug('restarting ------ ');
      LocalStorageService.setData('restarting', true);
      AppService.getInstance().restart();
    //}, 5000)

    //AppService.getInstance().connect(store.app.credentials.email, store.app.credentials.hash, true, true, store.settings);
  };
};

const doOffline = () =>{
  LoggingService.getInstance().info('AC ---- doOffline');
  return (dispatch, getState) =>{
    AlertService.getInstance().createErrorAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_LOST_CONNECTION', 'Lost network connection. Check connection status.'), isPersistent: true, type: 'noconnection'});
    // store dispatch
    //jes to put at the end of the call stack
    setTimeout(()=>{
      dispatch(doAppStatus({status: 'offline', details: {call: 'offline'}}));
    }, 0);
  };
};

const doSubmitLogin = (email, pwd, remember) => {
  LoggingService.getInstance().info('AC ---- doSubmitLogin',email,  remember);
  return (dispatch, getState) => {
    // fix callerid here
    LoggingService.getInstance().debug('>>>>>>>> doSubmitLogin', email, remember);
    dispatch(doDismissPersistent());
    const settings = getState().settings;
    AppService.getInstance().connect(email, pwd, false, remember, settings);
    // dispatching so we change from not authorized to pending
    dispatch(doingLogin({email, pwd, remember, settings}));
  };
};

const doForgotPassword = (email) =>{
  LoggingService.getInstance().info('AC ---- doForgotPassword', email);
  return (dispatch, getState) => {
    track('login', 'forgot', 'email', email);
    AppService.getInstance().speak('resetPassword', { email } ).then((data)=>{
      LoggingService.getInstance().debug('forgot returned: ', data);
      AlertService.getInstance().createInfoAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_FORGOT_PASSWORD', 'Forgot Password'), alertBodyText: data.description, isPersistent: false});
    }).catch((error)=>{
      LoggingService.getInstance().debug('forgot errored: ', error);
      AlertService.getInstance().createErrorAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_FORGOT_PASSWORD', 'Forgot Password'), alertBodyText: error.description, isPersistent: false});
    });
  };
};

const doLoginFailure = (payload,history) =>{
  LoggingService.getInstance().info('AC ---- doLoginFailure' );
  return (dispatch) =>{
    LoggingService.getInstance().debug('>>>>> doLoginFailure: ', !!payload);

    if (payload && typeof(payload.message) === 'string'){
      AlertService.getInstance().createErrorAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_LOGIN', 'Login'), alertBodyText: payload.message, isPersistent: false});
    } else {
      AlertService.getInstance().createErrorAlert({alertHeadingText: Utilities.getInstance().getIntlMessage('ALERT_LOGIN', 'Login'), isPersistent: false});
    }

    history.push('/appmain/login');
    dispatch ({
      "type": "LOGIN_FAILED",
      "payload": {},
      "meta": {
        "analytics":{
          'category':'login',
          'action': 'loginFailure'
        }
      }
    });
  };
};

const doLogOut = (payload) => {
  LoggingService.getInstance().info('AC ---- doLogOut');
  return (dispatch)=>{
      dispatch({
        "type": "LOGOUT",
        "payload": payload,
        "meta": {
          "analytics":{
            'category':'settings',
            'action': 'logout'
          }
        }
      });
      dispatch(doMedia());
  };

};

const doSubmitLogOut = (history) =>{
  LoggingService.getInstance().info('AC ---- doSubmitLogOut');
  return (dispatch, getState) => {

    const store = getState();

    // SOFTPHONE-195 - Issue with buggy transition/wrong screens when logging out during an active call. Therefore, user will no longer logout during active calls. User will simply see an alert. 
    // Must be done in doSubmitLogOut because AppService.getInstance().disconnect() is already called by the time doLogOut is invoked and continues to create our error. - KCN
    if(Object.keys(store.callInfo.inprogressCalls).length >= 1) {

      AlertService.getInstance().createErrorAlert({
        alertHeadingText : "You are currently on an active call and cannot log out.",
        isPersistent : false
      });

    } else {
      AppService.getInstance().disconnect();
      // dispatching so we change from not authorized to pending
      // Thunk here
      if (localStorage){
        localStorage.clear();
      }
      dispatch(doLogOut());
      history.push('/appmain/login');
    }
  };
};

const doingLogin = (data) => {
  LoggingService.getInstance().info('AC ---- doingLogin');
  return (dispatch)=>{
      dispatch({
      type: "AUTH_SUBMIT_LOGIN",
      payload: data,
      "meta": {
        "analytics":{
          'category':'login',
          'action': 'login'
        }
      }
    });
  };
};

export {doShowLogin, doReceiveAuthData, doReconnect, doForgotPassword, doExpiredPassword,
        doResetPassword, doNotNow, doSubmitLogin, doLoginFailure,
        doSubmitLogOut, doOffline };



// WEBPACK FOOTER //
// ./src/action-creators/login.js